export { StyledCloseButton } from './StyledCloseButton';
export { StyledContent } from './StyledContent';
export { StyledFooter } from './StyledFooter';
export { StyledHeader } from './StyledHeader';
export { StyledModal } from './StyledModal';
export { StyledOverlay } from './StyledOverlay';
export { StyledTitle } from './StyledTitle';
